import { IconTime } from '@flixbus/honeycomb-icons-react';

import { formatSummaryDateTime } from 'utils/datetime/fnsTimeFormatter';

import { CREATE_BREAKDOWN_FLOW_TEXT } from '../texts';

const LABELS = CREATE_BREAKDOWN_FLOW_TEXT.summary.rowLabels;

/**
 * @typedef {import('./summarySectionsRegistry').SummaryRow} SummaryRow
 */

/**
 * Build the row list for the Summary "Post-incident driving" accordion.
 *
 * @param {object} data
 * @returns {SummaryRow[]}
 */
export const derivePostIncidentDrivingRows = (data) => {
	if (!data?.driving?.fromTimestamp) return [];

	return [
		{
			label: LABELS.start,
			value: formatSummaryDateTime(data.driving.fromTimestamp),
			icon: IconTime,
		},
	];
};
